module.exports = __webpack_public_path__ + "static/media/edit-workspace-icon.ae1824b7.svg";